import CcoToken from './CcoToken'
export default CcoToken
